import { RemoteAuthenticationSendPasswordResetCode } from 'data/usecases';
import { AuthenticationSendPasswordResetCodeUseCaseInterface } from 'domain/usecases';
import { makeApiUrlResetPasswordSendCode } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationSendPasswordResetCode =
  (): AuthenticationSendPasswordResetCodeUseCaseInterface => {
    return new RemoteAuthenticationSendPasswordResetCode(
      makeApiUrlResetPasswordSendCode(),
      makeAxiosHttpClient(),
    );
  };
